import React, {Component} from 'react'
import PropTypes from 'prop-types'

import '../../styles/css/ProgressButton.css'


const propTypes = {
    backColor: PropTypes.string,
    progressColor: PropTypes.string,
    textColor: PropTypes.string,
    title: PropTypes.string.isRequired,
    progress: PropTypes.number.isRequired,
}

const defaultProps = {
    backColor: '#fff',
    progressColor: '#FCB800',
    textColor: 'black',
}


class ProgressButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentDidMount() {

    }

    render() {
      let container = document.getElementById('progress-button-container')
      var progressWidth = '100'
      if(container){
          progressWidth = parseInt(container.clientWidth * this.props.progress / 100, 10)
      }
        return (
            <div className="progress-button-container" id="progress-button-container" style={{
                backgroundColor: this.props.backColor
            }}>
                <div className="progress-container" style={{
                    backgroundColor: this.props.progressColor,
                    width: progressWidth,
                }} />

                <div className="progress-title-container">
                    <p className="progress-title" style={{ color: this.props.textColor }}>{this.props.title}</p>
                    <p className="progress-value" style={{ color: this.props.textColor }}>{parseInt(this.props.progress, 10)}%</p>
                </div>
            </div>
        )
    }
}

ProgressButton.propTypes = propTypes
ProgressButton.defaultProps = defaultProps

export default ProgressButton



// WEBPACK FOOTER //
// ./src/components/creatorawards/ProgressButton.js